<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>微信用户列表</el-breadcrumb-item>
        </el-breadcrumb>

        <div class="users" style="margin-top: 40px;padding-left: 40px;">
            <el-col :span="7" v-for="(o, index) in listData" :key="o" :offset="index > 0 ? 1 : 0">
                <el-card :body-style="{ padding: '0px' }" class="user-div">
                    <div class="avatar">
                        <el-image :src="o.head_url" v-if="o.head_url != null" class="avatar-img"></el-image>
                        <el-image src="/static/images/default_user.png" class="avatar-img"></el-image>
                    </div>
                    <div class="user-info">
                        <div class="nickname">{{o.nickname}}</div>
                        <div :class="o.nickname == undefined ? 'user-phone1': 'user-phone'">{{o.phone}}</div>
                    </div>
                    <div class="user-delete">
                        <img src="/static/images/user_delete.png" @click="deleteUser(o)">
                    </div>
                </el-card>
            </el-col>

            <el-col :span="7" :offset="listData.length % 3 == 0 ? 0 : 1">
                <el-card :body-style="{ padding: '0px' }" class="user-div" v-if="listData.length < 6">
                    <div class="add-user user-div" @click="handleEdit()">
                        <img src="/static/images/user_add.png"> <span>添加人员</span>
                    </div>
                </el-card>
            </el-col>
        </div>

        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisible" width="50%" @click="closeDialog('editForm')">
            <el-form label-width="120px" :model="editForm" ref="editForm">
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="电话号码">
                            <el-input size="small" v-model="editForm.phone" auto-complete="off"
                                      placeholder="请输入电话号码"></el-input>
                        </el-form-item>
                        <el-form-item label="用户权限">
                            <el-checkbox-group v-model="editForm.auth" @change="handleCheckedUserChange">
                                <el-checkbox v-for="a in auth" :label="a.id" :key="a.id">{{a.name}}</el-checkbox>
                                <el-checkbox :label="0" :key="0">禁用</el-checkbox>
                            </el-checkbox-group>
                        </el-form-item>

                        <el-form-item>
                            <div class="dialog-footer">
                                <el-button size="small" @click="closeDialog">取消</el-button>
                                <el-button size="small" type="primary" :loading="loading" class="title"
                                           @click="submitForm('editForm')">保存
                                </el-button>
                            </div>
                        </el-form-item>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import {addUser, deleteUser, users} from "../../api/userMG";

    export default {
        data() {
            return {
                loading: false, //是显示加载
                editFormVisible: false, //控制编辑页面显示与隐藏
                operatorVisible: false, //控制操作员页面显示与隐藏
                title: '添加操作员',
                editForm: {
                    auth: [],
                    phone: '',
                },
                auths: [],
                auth: [],
                listData: [], //用户数据
                listOperatorData: [], //操作员数据
            }
        },
        // 注册组件
        components: {},
        /**
         * 创建完毕
         */
        mounted(){

        },
        created() {
            this.getdata()
        },

        /**
         * 里面的方法只有被调用才会执行
         */
        methods: {
            getdata() {
                this.loading = true
                users().then(res => {
                    if(res.code == 200){
                        this.listData = res.result.user
                        this.auth = res.result.auth
                        this.loading = false
                    }
                })
            },
            //显示编辑界面
            handleEdit: function () {
                this.editFormVisible = true
            },
            handleCheckedUserChange(val) {
                if (val.length > 0) {
                    if (val[val.length - 1] == 0) {
                        this.editForm.auth = [0]
                    } else {
                        let u = val.sort()
                        if (u[0] == 0) {
                            u.splice(0, 1)
                        }
                        this.editForm.auth = val
                    }
                }
            },
            // 编辑、增加页面保存方法
            submitForm(editData) {
                this.$refs[editData].validate(valid => {
                    if (valid) {
                        let row = this.editForm
                        let params = {phone: row.phone, auth: row.auth}
                        addUser(params)
                            .then(res => {
                                this.editFormVisible = false
                                this.loading = false
                                if (res.code == 200) {
                                    this.$message({
                                        type: 'success',
                                        message: '保存成功！'
                                    })
                                    this.getdata()
                                } else {
                                    this.$message({
                                        type: 'info',
                                        message: '保存失败！'
                                    })
                                }
                            })
                            .catch(err => {
                                this.editFormVisible = false
                                this.loading = false
                                this.$message.error('管理员保存失败，请稍后再试!')
                            })
                    } else {
                        return false
                    }
                })
            },
            // 删除管理员
            deleteUser(row) {
                this.$confirm('确定要删除吗?', '信息', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((res) => {
                    let phone = row.phone
                    deleteUser({phone: phone})
                        .then(res => {
                            if (res.code == 200) {
                                this.$message({
                                    type: 'success',
                                    message: '管理员已删除!'
                                })
                                this.getdata()
                            } else {
                                this.$message({
                                    type: 'info',
                                    message: '管理员删除失败!'
                                })
                            }
                        })
                })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: '已取消删除'
                        })
                    })
            },
            // 关闭编辑、增加弹出框
            closeDialog(formName) {
                this.editFormVisible = false
                this.$refs[formName].resetFields()
            }
        }
    }
</script>

<style scoped>
    .user-div {
        width: 100%;
        height: 100px;
        margin: 20px 1%;
        float: left;
        border: 1px solid #EEEEEE;
    }

    .user-div div {
        float: left;
    }

    .avatar, .user-delete {
        line-height: 100px;
    }

    .avatar-img {
        margin-top: 4vh !important;
    }

    .avatar {
        margin-left: 20px;
    }

    .user-delete {
        float: right !important;
        margin-right: 20px;
        margin-top: 5px;
    }

    .user-info {
        margin-left: 20px;
        padding-top: 15px;
    }

    .user-phone1 {
        padding-top: 10px;
    }

    .user-info div {
        margin-top: 10px;
        width: 100%;
    }

    .add-user {
        line-height: 110px;
        text-align: center;
        background-color: #F3F3F3;
        font-size: 14px;
        margin: 0% !important;
    }

    .add-user span {
        color: #0052D9;
        margin-top: -20px;
    }

</style>



// WEBPACK FOOTER //
// src/views/user/index.vue